// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-input[data-v-278c61d4]{font-family:Mulish,helvetica neue,helvetica,arial,sans-serif;align-items:center;border:1px solid #ddd;border-radius:.25rem;display:flex;flex-grow:1;font-size:1rem;padding:0 1rem;margin:0;-webkit-appearance:none;appearance:none}.text-input.invalid[data-v-278c61d4]{border-color:#e36042!important}", ""]);
// Exports
module.exports = exports;
